import React from "react";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import { useTranslation } from "react-i18next";
import styles from "./sharedStyles.module.scss";
import type { SupportedSidecarChannel } from "@whatslly/commons/sidecarUtils";
import { CheckBox } from "@whatslly/ui-components/v2/BaseElements/CheckBox";
import { SidecarChannelType } from "@whatslly/types/sidecars-server/Sidecar";

interface InviteRemoteSyncSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  availableChannelsForCreation: { label: string; value: SupportedSidecarChannel }[];
  updateRemoteSyncChannels: (channel: SidecarChannelType, enabled: boolean) => void;
}

export const InviteRemoteSyncSwitch: React.FC<InviteRemoteSyncSwitchProps> = ({
  value,
  onChange,
  disabled,
  availableChannelsForCreation,
  updateRemoteSyncChannels,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.switchTextContainer}>
        <Switch testId="invite_to_remote_sync_switch" checked={value} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
        <span>{t("users_management.invite_to_remote_sync")}</span>
      </div>
      {value && (
        <div className={styles.defaultChannels}>
          {availableChannelsForCreation.map(({ label, value }) => (
            <CheckBox
              key={value}
              textFontSize="small"
              marginBottom="extra-small"
              text={label}
              onChange={(e) => updateRemoteSyncChannels(value, e.target.checked)}
              data-testid={`default-sidecar-channel-${value}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};
